export default __webpack_public_path__ + "static/media/help.ebb86122.svg";